// Time formatting helpers shared by the rail, lockout screen, and dashboard.

function pad(n) {
  return String(n).padStart(2, "0");
}

// HH:MM:SS in 24h, or HH:MM when { seconds: false }.
export function formatClock(ms, { seconds = true } = {}) {
  if (!ms) return "—";
  const d = new Date(ms);
  const base = `${pad(d.getHours())}:${pad(d.getMinutes())}`;
  return seconds ? `${base}:${pad(d.getSeconds())}` : base;
}

// Human-friendly "X min Ys" or "Xh Ym". `ms` is a future timestamp.
export function formatRelative(futureMs) {
  const diff = Math.max(0, futureMs - Date.now());
  const mins = Math.floor(diff / 60000);
  const secs = Math.floor((diff % 60000) / 1000);
  if (mins <= 0) return `${secs}s`;
  if (mins < 60) return `${mins} min ${pad(secs)}s`;
  const h = Math.floor(mins / 60);
  return `${h}h ${mins % 60}m`;
}
